import { useRef, useState } from "react";
import { Box, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AppButton from "../common/AppButton";
import AppSnackbar from "../common/AppSnackbar";
import AddNewCategoryModal from "./addNewCategoryModal";
import usePermissions from "../../hooks/usePermissions";

interface Iprops {
  setReloadCategory?: any;
  search?: string;
  setSearch: (val: string) => void;
  setPage: any;
}

const CategoryToolBar = ({
  setReloadCategory,
  search,
  setSearch,
  setPage,
}: Iprops) => {
  const [openAddSnackbar, setOpenAddSnackbar] = useState(false);
  const [addSnackbarMessage, setAddSnackbarMessage] = useState(
    "Added Successfully!"
  );
  const [isAddError, setIsAddError] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const debounceRef = useRef<NodeJS.Timeout | null>(null);
  const isPermissions = usePermissions();
  const Account_Type = parseInt(
    localStorage.getItem("pharmacy_account_type") || "0",
    10
  );

  const handleAddSuccess = () => {
    setAddSnackbarMessage("Added Successfully!");
    setIsAddError(false);
    setOpenAddSnackbar(true);
  };

  const handleAddError = (message: string) => {
    setAddSnackbarMessage(message || "This category already exists.");
    setIsAddError(true);
    setOpenAddSnackbar(true);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setSearch(val);
      setPage(0);
    }, 200);
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
          mt: 2,
        }}
      >
        <TextField
          variant="outlined"
          size="small"
          placeholder="Search Category"
          onChange={handleSearchChange}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{ width: "350px" }}
        />

        {(Account_Type === 0 || (isPermissions?.add && Account_Type === 1)) && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <AppButton
              title="Add New Category"
              onClick={handleOpenModal}
              padding="5px 10px 5px 10px"
              type="button"
            />
          </Box>
        )}

        {openModal && (
          <AddNewCategoryModal
            handleClose={handleCloseModal}
            setReloadCategory={setReloadCategory}
            onAddSuccess={handleAddSuccess}
            onAddError={handleAddError}
          />
        )}
      </Box>

      <AppSnackbar
        message={addSnackbarMessage}
        open={openAddSnackbar}
        handleClose={() => setOpenAddSnackbar(false)}
        severity={isAddError ? "error" : "success"}
      />
    </Box>
  );
};

export default CategoryToolBar;
